import React, {Component} from 'react';
import IncomingItem from './IncomingItem.js';

export default class IncomingOrders extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        if(this.props.orders.length > 0){
            return (
                <div>
                    {this.props.orders.map((order, index) =>
                        (   <div key={index}>
                                <IncomingItem order={order} hotelId={this.props.hotelId} />
                            </div>
                        ))}
                </div>
            )
        }else{
            return (
                <div>There are no incoming orders</div>
            )
        }

    }
}


// WEBPACK FOOTER //
// ./src/components/Dashboard/IncomingOrders.js